<template>
	<div class="fullBoxs" v-loading.fullscreen.lock="fullscreenLoading">
		<dialogBox :dialogFlag="fxFlag" @callFn="fxFlag = false" @qrsFn="subBjFn" :title="`分享本课时词句到班级`">
			<el-form :model="ruleForm" ref="ruleForm" :rules="rules" style="width: 430px" label-width="80px">
				<el-form-item label="创建词簿">
					<p>{{ ruleForm.name }}</p>
				</el-form-item>
				<el-form-item label="选择班级" prop="bjId">
					<el-select style="width: 100%" v-model="ruleForm.bjId" @change="fxFn" filterable allow-create default-first-option placeholder="请选择">
						<el-option v-for="(item, index) in bjList" :key="index" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
		</dialogBox>
		<dialogBox :dialogFlag="mrytFlag" @callFn="mrytFlag = false" title="播放完整音频开始模拟考试">
			<template v-slot:footer>
				<div slot="footer">
					<div class="dialog-footer">
						<div class="loadBtn loadBtnQr supHove3" style="margin-left: 0" @click="ksBtn">开始考试</div>
						<div class="loadBtn supHove3" style="margin-left: 50px" @click="mrytFlag = false">继续准备</div>
					</div>
				</div>
			</template>
		</dialogBox>
		<dialogBox :dialogFlag="lkFlag" @callFn="lkFlag = false" title="您确定提交本次答题卷么？">
			<div class="tcBox">
				<div class="tcItem tcItem1">
					<img src="@/assets/img/tm.svg" alt="" />
					<p>共有：{{ tmTnum.num }}题</p>
				</div>
				<div class="tcItem tcItem2">
					<img src="@/assets/img/yz.svg" alt="" />
					<p>已做：{{ tmTnum.yzNum }}题</p>
				</div>
				<div class="tcItem tcItem3">
					<img src="@/assets/img/wz.svg" alt="" />
					<p>未做：{{ tmTnum.wzNum }}题</p>
				</div>
			</div>
			<template v-slot:footer>
				<div slot="footer">
					<div class="dialog-footer">
						<div class="loadBtn supHove3" @click="lkFn">确认离开</div>
						<div class="loadBtn loadBtnQr supHove3" @click="lkFlag = false">继续答题</div>
					</div>
				</div>
			</template>
		</dialogBox>
		<dialogBox :dialogFlag="subFlag" @callFn="tcFn" title="您确定提交本次答题卷么？">
			<div class="tcBox">
				<div class="tcItem tcItem1">
					<img src="@/assets/img/tm.svg" alt="" />
					<p>共有：{{ tmTnum.num }}题</p>
				</div>
				<div class="tcItem tcItem2">
					<img src="@/assets/img/yz.svg" alt="" />
					<p>已做：{{ tmTnum.yzNum }}题</p>
				</div>
				<div class="tcItem tcItem3">
					<img src="@/assets/img/wz.svg" alt="" />
					<p>未做：{{ tmTnum.wzNum }}题</p>
				</div>
			</div>
			<template v-slot:footer>
				<div slot="footer">
					<div class="dialog-footer">
						<div class="loadBtn supHove3" @click="subTjFn">确认提交</div>
						<div class="loadBtn loadBtnQr supHove3" @click="tcFn">继续答题</div>
					</div>
					<p class="footerP">
						页面停留
						<span>{{ times }}s</span>
						时间无响应系统自动提交
					</p>
				</div>
			</template>
		</dialogBox>
		<userHeader />
		<fuHeader />
		<div class="fullBox" :class="{ fullBox1: msType == 2, fullBox2: msType == 3 }">
			<crumbs type="2" height="53px" />
			<div class="bodyWrapper">
				<div class="gudBtns">
					<div class="gudBtnItem gudBack supHove3" @click="$router.back()">
						<img src="@/assets/img/back.svg" alt="" />
						<span>返回</span>
					</div>
				</div>
				<div class="tlTabs" v-if="textbookId">
					<div class="tlTabItem supHove3" @click="tabFlag = 1" :class="{ active: tabFlag == 1 }">
						<img src="@/assets/img/xuex.png" v-show="tabFlag == 1" alt="" />
						<img src="@/assets/img/xuex (3).svg" v-show="tabFlag == 2" alt="" />
						<span>试题</span>
					</div>
					<div class="tlTabItem supHove3" @click="tabFlag = 2" :class="{ active: tabFlag == 2 }">
						<img src="@/assets/img/xwci.svg" v-show="tabFlag == 2" alt="" />
						<img src="@/assets/img/xci.svg" v-show="tabFlag == 1" alt="" />
						<span>词语</span>
					</div>
				</div>
				<div class="ciBox" v-if="tabFlag == 2">
					<div class="cihuiBox">
						<div class="cihuiBoxTit">
							<div class="cihuiBoxQx">
								<h2 @click="tabsFn(1)" :class="{ qxActive: qxFlag == 1 }">词汇</h2>
								<h2 @click="tabsFn(2)" :class="{ qxActive: qxFlag == 2 }">地道表达</h2>
								<h2 @click="tabsFn(3)" :class="{ qxActive: qxFlag == 3 }">熟词新义</h2>
							</div>
							<div class="cihuiBoxBtns">
								<div class="cihuiBoxBtn supHove3" @click="xzBtn">
									<img src="@/assets/img/xiazai.svg" alt="" />
									下载词汇
								</div>
								<div class="cihuiBoxBtn cihuiBoxBtn1 supHove3" @click="fxFn">
									<img src="@/assets/img/fxIcon.svg" alt="" />
									分享班级
								</div>
							</div>
						</div>
						<div class="cihuiCont">
							<div class="cihuiItem" v-for="(item, index) in chData" :key="index">
								<div class="cihuiItemLef">
									<div class="fgP">
										<h2 v-if="qxFlag != 2">{{ item.words }}</h2>
										<h2 v-if="qxFlag == 2">{{ item.sentence }}</h2>
										<p v-if="qxFlag != 2">{{ item.phoneticMark }}</p>
										<img src="@/assets/img/编组 10.png" class="supHove3" v-show="!item.audioFlag" @click="ypBtn(item)" alt="" />
										<img src="@/assets/img/bf.svg" v-show="item.audioFlag" alt="" />
									</div>
									<p v-if="qxFlag != 3">释义：{{ item.partSpeech ? item.partSpeech + '.' : '' }}{{ item.paraphrase }}</p>
									<p class="ass" v-if="qxFlag == 3">
										例句：
										<span v-html="item.sentence"></span>
									</p>
									<p v-if="qxFlag == 3">语篇新义：{{ item.oldPartSpeech }}.{{ item.oldParaphrase }}</p>
									<p v-if="qxFlag == 3">常用语义：{{ item.partSpeech }}.{{ item.paraphrase }}</p>
								</div>
								<div class="cihuiItemRig" v-if="qxFlag == 1">
									<div class="cihuiItemRigT">
										<div
											class="cihuiItemRigTBtn"
											:class="`cihuiItemRigTBtn${index + 1}`"
											v-for="(item, index) in item.classificationNames?.split(',')"
											:key="index"
										>
											{{ item }}
										</div>
									</div>
									<p>来源：{{ item.createNickName }}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="kaoshiBox" v-if="tabFlag == 1">
					<div class="kaoshiFixYs">
						<div class="kaoshiFixYsCont">
							{{ bsData.slice(bsIns, bsIns + 1)[0] + 'x' }}
						</div>
						<div class="kaoshiFixP">
							<img src="@/assets/img/x.png" @click="yusFn('-')" class="img1 supHove3" alt="" />
							<p>语速调节</p>
							<img src="@/assets/img/s.svg" @click="yusFn('+')" class="img2 supHove3" alt="" />
						</div>
					</div>
					<div class="kaoshiFixBtns">
						<div class="kaoshiFixBtn supHove3" @click="ksFn" v-if="ksStatus != 2">
							<img src="@/assets/img/ks (2).svg" alt="" />
							<p>开始考试</p>
						</div>
						<div class="kaoshiFixBtn supHove3" @click="jyBtn">
							<img src="@/assets/img/jy.svg" v-show="!jyFlag && msType != 3" alt="" />
							<img src="@/assets/img/jy2.svg" v-show="jyFlag && msType != 3" alt="" />
							<img src="@/assets/img/jy3.svg" v-show="jyFlag && msType == 3" alt="" />
							<img src="@/assets/img/jy4.svg" v-show="!jyFlag && msType == 3" alt="" />
							<p :style="{ color: jyFlag && msType != 3 ? '#1D7B3A' : '#82807C' || (jyFlag && msType == 3) ? '#82807C' : '#82807C' }">静音</p>
						</div>
						<div class="kaoshiFixBtn supHove3" @click="msBtn">
							<img src="@/assets/img/hy.svg" v-show="msType == 1" alt="" />
							<img src="@/assets/img/yj.svg" v-show="msType == 2" alt="" />
							<img src="@/assets/img/zc.svg" v-show="msType == 3" alt="" />
							<p>护眼</p>
						</div>
						<div class="kaoshiFixBtn kaoshiFixBtn1 supHove3" v-if="ksStatus == 2" @click="subjBnt">
							<i class="el-icon-switch-button"></i>
							<p>结束考试</p>
						</div>
					</div>
					<div class="kaoshiCont" v-if="templateType == 1">
						<h1>
							{{ tmDec.name }}
							<!-- <img src="@/assets/img/ks (2).svg" @click="mrytFlag=true" alt="" v-if="listenEveryDayId"> -->
						</h1>
						<h2>（选择题{{ tmTnum.num }}小题，每题{{ configData.configValue || '' }}分，共{{ tmTnum.num * configData.configValue || '' }}分）</h2>
						<div class="kaoshiTm">
							<h3>第一节</h3>
							<p>
								听下面
								<span>5</span>
								段录音。每段录音后有一个小题，从题中所给的
								<span>A、B、C</span>
								三个选项中选出最佳选项。听完每段录音后，你都有
								<span>10</span>
								秒钟的时间来回答有关小题和阅读下一小题。每段录音播放两遍。
							</p>
							<div class="kaoshiXtim" v-for="(item, index) in tmDec.yydTextbookQuestions?.slice(0, 5)" :key="index">
								<h4 v-if="item.tmName">{{ item.tmName }}</h4>
								<div class="kaoshiT" v-for="(a, b) in item.yydSmallQuestionList" :key="b">
									<div class="kaoshiWt">
										<div class="kaoshiDa">
											<i>(</i>
											<span>{{ a.nums }}</span>
											<i>)</i>
										</div>
										{{ a.num }}、{{ a.title }}
									</div>
									<div class="kaoshiXx">
										<p :class="{ active: a.nums == i.number }" v-for="(i, s) in a.yydSmallQuestionOptionList" :key="s" @click="daBtn(a, i)">
											{{ i.number }}、{{ i.content }}
										</p>
									</div>
								</div>
							</div>
						</div>
						<div class="kaoshiTm">
							<h3>第二节</h3>
							<p>
								听下面
								<span>5</span>
								段录音。每段录音后有几个小题，从题中所给的
								<span>A、B、C</span>
								三个选项中选出最佳选项。听每段录音前，你将有时间阅读各个小题，每小题
								<span>5</span>
								秒钟；听完后，每小题都有
								<span>5</span>
								秒钟的作答时间。每段录音播放两遍。
							</p>
							<div class="kaoshiXtim" v-for="(item, index) in tmDec.yydTextbookQuestions?.slice(5)" :key="index">
								<h4>
									听第{{ 6 + index }}段录音，回答第{{
										item.yydSmallQuestionList.length > 2
											? item.yydSmallQuestionList[0].num + '至' + item.yydSmallQuestionList[item.yydSmallQuestionList.length - 1].num
											: item.yydSmallQuestionList
													.map((is) => {
														return is.num;
													})
													.join('、')
									}}题。
								</h4>
								<div class="kaoshiT" v-for="(a, b) in item.yydSmallQuestionList" :key="b">
									<div class="kaoshiWt">
										<div class="kaoshiDa">
											<i>(</i>
											<span>{{ a.nums }}</span>
											<i>)</i>
										</div>
										{{ a.num }}、{{ a.title }}
									</div>
									<div class="kaoshiXx">
										<p :class="{ active: a.nums == i.number }" v-for="(i, s) in a.yydSmallQuestionOptionList" :key="s" @click="daBtn(a, i)">
											{{ i.number }}、{{ i.content }}
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="kaoshiCont" v-if="templateType == 2">
						<h1>{{ tmDec.name }}</h1>
						<h2>（选择题{{ tmTnum.num }}小题，每题{{ configData.configValue || '' }}分，共{{ tmTnum.num * configData.configValue || '' }}分）</h2>
						<div class="kaoshiTm">
							<!-- <h3>第一节</h3> -->
							<p v-if="txType == 1">
								听下面{{
									tmDec.yydTextbookQuestions?.length
								}}段录音。每段录音后有一个小题，从题中所给的A、B、C三个选项中选出最佳选项。听完每段录音后，你都有10秒钟的时间来回答有关小题和阅读下一小题。每段录音播放两遍。
							</p>
							<p v-else>
								听下面{{ tmDec.yydTextbookQuestions?.length }}段录音。每段录音后有几个小题，从题中所给的A、B、C三个选项中选出最佳选项。听每段录音前，你将有时间阅读各个小题，每小题5秒钟；听完后，每小题都有5秒钟的作答时间。每段录音播放两遍。
							</p>
							<div class="kaoshiXtim" v-for="(item, index) in tmDec.yydTextbookQuestions" :key="index">
								<h4 v-if="txType == 2">
									听第{{ 1 + index }}段录音，回答第{{
										item.yydSmallQuestionList.length > 2
											? item.yydSmallQuestionList[0].num + '至' + item.yydSmallQuestionList[item.yydSmallQuestionList.length - 1].num
											: item.yydSmallQuestionList
													.map((is) => {
														return is.num;
													})
													.join('、')
									}}题。
								</h4>
								<h4 v-if="item.tmName">{{ item.tmName }}</h4>
								<div class="kaoshiT" v-for="(a, b) in item.yydSmallQuestionList" :key="b">
									<div class="kaoshiWt">
										<div class="kaoshiDa">
											<i>(</i>
											<span>{{ a.nums }}</span>
											<i>)</i>
										</div>
										{{ a.num }}、{{ a.title }}
									</div>
									<div class="kaoshiXx">
										<p :class="{ active: a.nums == i.number }" v-for="(i, s) in a.yydSmallQuestionOptionList" :key="s" @click="daBtn(a, i)">
											{{ i.number }}、{{ i.content }}
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<foot v-if="type" />
		</div>
	</div>
</template>

<script>
import userHeader from '@/components/hearder/userHeader';
import foot from '@/components/foot/foot';
import fuHeader from '@/components/hearder/fuHeader';
import crumbs from '@/components/hearder/crumbs';
import dialogBox from '@/components/pubComponents/dialogBox';
import axios from 'axios';
import jsFileDownload from 'js-file-download';

export default {
	name: 'kaoShi',
	data() {
		return {
			a: ['个人中心'],
			txt: '',
			strName: '',
			bjList: [],
			templateId: '',
			mrytFlag: false,
			rules: {
				bjId: [{ required: true, message: '请选择课本', trigger: 'blur' }]
			},
			tmTnum: {
				num: 0,
				wzNum: 0,
				yzNum: 0
			},
			ruleForm: {
				bjId: '',
				name: '',
				wordsIds: ''
			},
			collegeExaminationId: '',
			listenEveryDayId: '',
			groupExamId: '',
			fxFlag: false,
			chData: [],
			ksStatus: 1, // 1未考试 2考试中 3考试结束
			fullscreenLoading: false,
			configData: {},
			subFlag: false,
			lkFlag: false,
			qxFlag: 1,
			bsIns: 2,
			tabFlag: 1,
			type: '',
			tmDec: {},
			jyFlag: false, // 静音模式
			msType: 1, // 模式切换 1正常 2护眼 3夜间
			bsData: ['0.5', '0.75', '1', '1.25', '1.5', '1.75'],
			setFn: '',
			times: 60,
			nextName: '',
			nextQuery: '',
			nextParams: '',
			templateType: '',
			txType: 1,
			textbookDirectoryId: '',
			textbookId: ''
		};
	},
	components: {
		userHeader,
		crumbs,
		dialogBox,
		fuHeader,
		foot
	},
	beforeDestroy() {
		if (this.setFn) {
			clearInterval(this.setFn);
		}
	},
	beforeRouteLeave(to, from, next) {
		if (this.ksStatus != 2) {
			next();
			return;
		}
		if (to.path == '/kaoshiZj' || to.query.tys == '777') {
			next();
		} else {
			this.nextQuery = to.query;
			this.nextParams = to.params;
			this.nextName = to.path;
			this.tjFn();
			this.lkFlag = true;
		}
	},
	methods: {
		ksFn() {
			this.mrytFlag = true;
			// if(this.listenEveryDayId){
			//   this.mrytFlag=true
			// }else{
			//   this.ksBtn()
			// }
		},
		mrytFn() {
			this.mrytFlag = !this.mrytFlag;
		},
		xzBtn() {
			axios({
				method: 'post',
				url: `api/app/yydTextbookIdiomaticExpression/export/${this.textbookDirectoryId}`,
				responseType: 'blob', // 返回类型为数据流
				headers: {
					clientType: 1,
					token: `${localStorage.getItem('token')}`
				},
				data: {} // 需要传参的话，在这传
			}).then((res) => {
				if (res && res.data) {
					console.log(res, 7777);
					// 调用js-file-download下载文件，第一个参数是数据流，第二个参数是文件名，我这后端返回时把文件名放到响应的header的filename字段中，所以用这种方式取出
					jsFileDownload(res.data, decodeURIComponent('词汇.docx'));
				}
			});
		},
		ypBtn(item) {
			console.log(item, 9999);
			this.fullscreenLoading = true;
			item.audioFlag = true;
			this.$http
				.get('api/app/common/getUrl', {
					params: {
						fileId: item.audioFileId,
						clientType: 1
					}
				})
				.then((res) => {
					this.fullscreenLoading = false;
					if (res.code == 200) {
						axios({
							method: 'get',
							url: res.msg,
							// timeout: 600000, // 请求超时时间，数据量多后台响应慢的情况可以调大点，没生效的话可能是vue.config.js里的配置影响了
							responseType: 'blob', // 返回类型为数据流
							headers: {
								clientType: 1,
								token: `${localStorage.getItem('token')}`
							}
						}).then((red) => {
							if (red && red.data) {
								const blob = new Blob([red.data], { type: 'audio/mpeg' });
								item.questionAudioFilePath = URL.createObjectURL(blob);
								this.$audio.init(URL.createObjectURL(blob), (r) => {
									item.audioFlag = false;
								});
								this.$nextTick((r) => {
									this.$audio.play();
								});
							} else {
								item.audioFlag = false;
							}
						});
					} else {
						item.audioFlag = false;
					}
				});
		},
		subBjFn() {
			this.$refs['ruleForm'].validate((valid) => {
				if (valid) {
					// let wordsIds = ''
					// if(this.qxFlag==2){
					//   wordsIds = this.chData.map(item => {
					//     return item.idiomaticExpressionId
					//   })
					// }else{
					//   wordsIds = this.chData.map(item => {
					//     return item.wordsId
					//   })
					// }
					this.fullscreenLoading = true;
					this.$http
						.post(`api/app/yydWordsGroup`, {
							bjId: this.ruleForm.bjId,
							name: this.ruleForm.name,
							type: this.qxFlag,
							textbookDirectoryId: this.textbookDirectoryId
						})
						.then((res) => {
							this.fullscreenLoading = false;
							if (res.code == 200) {
								this.$message({
									message: '分享成功',
									type: 'success'
								});
								this.fxFlag = false;
							}
						});
				}
			});
		},
		fxFn() {
			this.fullscreenLoading = true;
			this.$http.get(`api/app/yydWordsGroup/getNo/${this.ruleForm.bjId}`).then((res) => {
				this.fullscreenLoading = false;
				if (res.code == 200) {
					this.fxFlag = true;
					this.ruleForm.name = res.data;
				}
			});
		},
		ksBtn() {
			this.$audio.playbackRate(this.bsData.slice(this.bsIns, this.bsIns + 1)[0]);
			this.$audio.playvolume(this.jyFlag ? 0 : 1);
			this.$audio.play();
			this.times = this.$audio.tiemFn();
			this.setFn = setInterval(() => {
				if (this.times == 0) {
					if (this.setFn) {
						clearInterval(this.setFn);
					}
					this.subTjFn();
					return;
				}
				console.log(this.times, 'this.times');
				this.times--;
			}, 1000);
			this.ksStatus = 2;
			this.mrytFlag = false;
		},
		jyBtn() {
			this.jyFlag = !this.jyFlag;
			this.$audio.playvolume(this.jyFlag ? 0 : 1);
		},
		tabsFn(type) {
			this.qxFlag = type;
			this.chFn();
		},
		lkFn() {
			this.lkFlag = false;
			if (this.$audio) {
				this.$audio.jumpToHalf(0);
				this.$audio.pause();
			}
			this.$router.push({
				path: this.nextName,
				query: {
					...this.nextQuery,
					tys: 777
				},
				params: {
					...this.nextParams
				}
			});
			console.log(this.nextName, '离开了');
		},
		subjBnt() {
			this.subFlag = true;
			this.tjFn();
		},
		tjFn() {
			let yz = 0;
			let wz = 0;
			this.tmDec.yydTextbookQuestions.forEach((item) => {
				item.yydSmallQuestionList.forEach((i) => {
					if (i.nums) {
						yz++;
					} else {
						wz++;
					}
				});
			});
			this.tmTnum.yzNum = yz;
			this.tmTnum.wzNum = wz;
		},
		subTjFn() {
			console.log(this.tmDec, 9999);
			let datas = {
				examId: '',
				list: [],
				textbookDirectoryId: '',
				type: ''
			};
			if (this.textbookId) {
				datas.examId = this.textbookId;
				datas.textbookDirectoryId = this.textbookDirectoryId;
				datas.type = 1;
			}
			if (this.collegeExaminationId) {
				datas.examId = this.collegeExaminationId;
				datas.type = 3;
			}
			if (this.listenEveryDayId) {
				datas.examId = this.listenEveryDayId;
				datas.type = 2;
			}
			if (this.groupExamId) {
				datas.examId = this.groupExamId;
				datas.type = 5;
			}
			this.tmDec.yydTextbookQuestions.forEach((item) => {
				item.yydSmallQuestionList.forEach((i) => {
					datas.list.push({
						examinationQuestionCallId: this.textbookId ? item.textbookQuestionId : item.groupExamQuestionId,
						smallQuestionId: i.smallQuestionId,
						userAnswer: i.nums
					});
				});
			});
			console.log(datas, 77778888);
			let set = this.$loading(this.$pre);
			this.$http.post(`api/app/yydAnswerExam/add/examAnswer`, datas).then((res) => {
				set.close();
				if (res.code == 200) {
					if (this.$audio) {
						this.$audio.jumpToHalf(0);
						this.$audio.pause();
					}
					this.ksStatus = 3;
					this.tcFn();
					this.$message({
						message: '交卷成功',
						type: 'success'
					});
					let decData = JSON.stringify(res.data);
					let data = {};
					if (this.textbookId) {
						data = {
							textbookDirectoryId: this.textbookDirectoryId,
							textbookId: this.textbookId
						};
					}
					if (this.collegeExaminationId) {
						data = {
							collegeExaminationId: this.collegeExaminationId
						};
					}
					if (this.listenEveryDayId) {
						data = {
							listenEveryDayId: this.listenEveryDayId
						};
					}
					if (this.groupExamId) {
						data = {
							groupExamId: this.groupExamId
						};
					}
					let str = this.a[2] + '~' + '考试完成';
					this.$router.push({
						path: 'kaoshiZj',
						query: {
							type: 1,
							txt: str,
							tabFtxt: this.a[1],
							decData,
							templateType: this.templateType,
							txType: this.txType,
							templateId: this.templateId,
							decName: this.tmDec.name,
							...data
						}
					});
				}
			});
		},
		tcFn() {
			this.subFlag = false;
		},
		daBtn(a, i) {
			console.log(a, i, 99999);
			if (this.ksStatus == 2) {
				a.nums = i.number;
			}
		},
		msBtn() {
			if (this.msType == 3) {
				this.msType = 1;
			} else {
				this.msType++;
			}
		},
		breaFn() {
			this.$router.back();
		},
		yusFn(type) {
			if (type == '-') {
				if (this.bsIns == 0) return;
				this.bsIns--;
			} else {
				if (this.bsIns == 5) return;
				this.bsIns++;
			}
			this.$audio.playbackRate(this.bsData.slice(this.bsIns, this.bsIns + 1)[0]);
		},
		chFn() {
			this.fullscreenLoading = true;
			this.chData = [];
			if (this.qxFlag == 1) {
				// 词汇
				this.$http
					.get(`api/app/yydTextbookWords/list`, {
						params: {
							textbookDirectoryId: this.textbookDirectoryId,
							textbookId: this.textbookId
						}
					})
					.then((res) => {
						this.fullscreenLoading = false;
						if (res.code == 200) {
							res.rows.forEach((item) => {
								item.audioFlag = false;
							});
							this.chData = res.rows || [];
						}
					});
			} else if (this.qxFlag == 2) {
				// 地道表达
				this.$http
					.get(`api/app/yydTextbookIdiomaticExpression/list`, {
						params: {
							textbookDirectoryId: this.textbookDirectoryId,
							textbookId: this.textbookId
						}
					})
					.then((res) => {
						this.fullscreenLoading = false;
						if (res.code == 200) {
							res.rows.forEach((item) => {
								item.audioFlag = false;
							});
							this.chData = res.rows || [];
						}
					});
			} else if (this.qxFlag == 3) {
				// 熟词新意
				this.$http
					.get(`api/app/yydTextbookNoveltyFamiliarWords/list`, {
						params: {
							textbookDirectoryId: this.textbookDirectoryId,
							textbookId: this.textbookId
						}
					})
					.then((res) => {
						this.fullscreenLoading = false;
						if (res.code == 200) {
							res.rows.forEach((item) => {
								item.audioFlag = false;
							});
							this.chData = res.rows || [];
						}
					});
			}
		},
		init() {
			let str = '';
			str = this.tmDec.yydTextbookQuestions
				.map((item) => {
					return item.number;
				})
				.join(',');
			console.log(str, 222);
			if (str.includes('D') && str.includes('Q')) {
				this.strName = '对话或独白';
			}
			if (str.includes('Q') && !str.includes('D')) {
				this.strName = '对话';
			}
			if (str.includes('D') && !str.includes('Q')) {
				this.strName = '独白';
			}

			// 得分
			this.$http.get(`api/system/dict/data/config/sys.question.score`).then((res) => {
				if (res.code == 200) {
					this.configData = res.data;
				}
			});
			if (this.textbookId) {
				// 班级列表
				this.$http.get(`api/app/yydBj/list`).then((res) => {
					if (res.code == 200) {
						console.log(res, 444);
						this.bjList = res.rows || [];
						this.ruleForm.bjId = this.bjList[0].id;
					}
				});
				this.chFn();
			}
		}
	},
	async mounted() {
		const { txt, type, tabFtxt, textbookId, templateId, textbookDirectoryId, collegeExaminationId, listenEveryDayId, groupExamId } = this.$route.query;
		if (tabFtxt) {
			this.a = typeof tabFtxt == 'string' ? [tabFtxt] : [...tabFtxt];
		}
		this.txt = txt || '';
		if (templateId) {
			this.templateId = templateId;
			// 判断长对话 还是短对话
			this.$http.get(`api/app/yydQuestionTypeTemplate/detail/${templateId}`).then((res) => {
				if (res.code == 200) {
					this.templateType = res.data.templateType;
					this.txType = res.data.type;
					console.log(res, 77777);
				}
			});
		}
		let res = '';
		if (textbookId) {
			// 课本进入
			this.textbookDirectoryId = textbookDirectoryId || '';
			this.textbookId = textbookId;
			this.fullscreenLoading = true;
			res = await this.$http.get(`api/app/yydTextbookDirectory/detail/${textbookDirectoryId}`);
		}
		if (collegeExaminationId) {
			// 高考真题
			this.collegeExaminationId = collegeExaminationId;
			this.fullscreenLoading = true;
			let datas = await this.$http.get(`api/app/yydCollegeExamination/${collegeExaminationId}`);
			if (datas.code == 200) {
				res = {
					code: 200,
					data: {
						name: datas.data.title,
						audioId: datas.data.questionAudioFileId,
						yydTextbookQuestions: datas.data.yydExamination.yydExaminationQuestionList
					}
				};
			}
		}
		if (listenEveryDayId) {
			// 每日一听
			this.listenEveryDayId = listenEveryDayId;
			this.fullscreenLoading = true;
			let datas = await this.$http.get(`api/app/yydListenEveryDay/${this.listenEveryDayId}`);
			if (datas.code == 200) {
				res = {
					code: 200,
					data: {
						name: datas.data.title,
						audioId: datas.data.questionAudioFileId,
						yydTextbookQuestions: datas.data.yydExamination.yydExaminationQuestionList
					}
				};
			}
		}
		if (groupExamId) {
			// 组卷
			this.groupExamId = groupExamId;
			this.fullscreenLoading = true;
			let datas = await this.$http.post(`api/app/yydGroupQuestionExam/pagerInfo`, {
				id: this.groupExamId
			});
			if (datas.code == 200) {
				res = {
					code: 200,
					data: {
						name: datas.data.title,
						audioId: datas.data.questionAudioFileId,
						yydTextbookQuestions: datas.data.yydGroupExamQuestionBodyDtoList
					}
				};
			}
		}

		if (res.data) {
			if (!groupExamId) {
				this.fullscreenLoading = false;
			}
			if (res.code == 200) {
				if (res.data.audioId) {
					this.$http
						.get('api/app/common/getUrl', {
							params: {
								fileId: res.data.audioId,
								clientType: 1
							}
						})
						.then((res) => {
							if (res.code == 200) {
								axios({
									method: 'get',
									url: res.msg,
									// timeout: 600000, // 请求超时时间，数据量多后台响应慢的情况可以调大点，没生效的话可能是vue.config.js里的配置影响了
									responseType: 'blob', // 返回类型为数据流
									headers: {
										clientType: 1,
										token: `${localStorage.getItem('token')}`
									}
								}).then((red) => {
									if (red && red.data) {
										const blob = new Blob([red.data], { type: 'audio/mpeg' });
										this.$audio.init(URL.createObjectURL(blob), (r) => {});
										this.$nextTick(() => {
											if (groupExamId) {
												this.fullscreenLoading = false;
												// this.$audio.playbackRate(this.bsData.slice(this.bsIns,this.bsIns+1)[0])
												// this.$audio.playvolume(this.jyFlag?0:1)
												// this.$audio.play()
												// this.ksStatus=2
											}
										});
									}
								});
							}
						});
				}
				let datas = res.data;
				console.log(datas, 99777777);
				let num = 1;
				datas.yydTextbookQuestions.forEach((item) => {
					item.yydSmallQuestionList.forEach((i) => {
						i.num = num;
						i.nums = '';
						num++;
					});
				});
				this.tmTnum.num = num - 1;
				this.tmDec = datas;
				console.log(this.tmDec, 222);
				this.init();
			}
		}
		this.type = type || '';
		if (this.txt.includes('~')) {
			this.a.push(...this.txt?.split('~'));
		} else {
			this.a.push(this.txt);
		}
	}
};
</script>
<style lang="scss" scoped>
.ciBox {
	background: #ffffff;
	width: 1200px;
	margin: 0 auto;
	box-sizing: border-box;
}
.tlTabs {
	padding: 4px;
	background: #fff;
	border-radius: 4px;
	display: flex;
	margin: 0 auto 10px;
	width: 1200px;
	box-sizing: border-box;
	.tlTabItem {
		flex: 1;
		height: 48px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 18px;
		color: #6d6e70;
		border-radius: 4px;
		cursor: pointer;
		img {
			width: 26px;
			height: 26px;
			margin-right: 5px;
		}
		:first-of-type {
			margin-right: 4px;
		}
	}
	.active {
		background: linear-gradient(180deg, #1d7b3a 0%, #1d7b3a 100%);
		color: #fff;
	}
}
.tcBox {
	margin: -16px 0 40px;
	display: flex;
	justify-content: space-between;
	.tcItem {
		width: 133px;
		height: 93px;
		background: #f8f9fd;
		border-radius: 4px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		font-size: 16px;
		img {
			width: 34px;
			height: 34px;
			margin-bottom: 7px;
		}
	}
	.tcItem1 {
		color: #000000;
	}
	.tcItem2 {
		color: #10c257;
	}
	.tcItem3 {
		color: #ffb126;
	}
}
.footerP {
	text-align: center;
	font-size: 14px;
	color: #82807c;
	margin-top: 12px;
	span {
		color: #1d7b3a;
		margin-right: 4px;
	}
}
.dialog-footer {
	display: flex;
	justify-content: center;
	padding-bottom: 10px;

	.loadBtn {
		width: 88px;
		height: 40px;
		text-align: center;
		line-height: 40px;
		background: #d33931;
		box-shadow: 0px 1px 2px 0px rgba(184, 200, 224, 0.22);
		font-size: 16px;
		color: #ffffff;
		border-radius: 6px;
		cursor: pointer;
	}
	.loadBtnQr {
		background: #1d7b3a;
		color: #ffffff;
		margin-left: 50px;
	}
}
.fullBox1 {
	background: #e8e3d7 !important;
	.kaoshiBox {
		background: #f4f0e7 !important;
	}
	.kaoshiCont {
		color: #484745 !important;
		h2 {
			border-bottom: 1px solid #ddd9d2 !important;
		}
	}
	.tlTabs {
		color: #484745 !important;
		background: #f4f0e7 !important;
	}
}
.fullBox2 {
	background: #202020 !important;
	.kaoshiBox {
		background: #252525 !important;
	}
	.kaoshiCont {
		color: #b3b3b3 !important;
		h2 {
			border-bottom: 1px solid #979797 !important;
		}
	}
	.kaoshiFixBtn,
	.tlTabs {
		background: #252525 !important;
		color: #82807c !important;
	}
}
.fullBox {
	background: #f3f4f7;
	min-height: calc(100vh - 113px);
	.kaoshiBox {
		width: 1200px;
		margin: 0 auto;
		position: relative;
		background: #ffffff;
		border-radius: 4px;
		box-sizing: border-box;
		padding: 0 80px 20px 50px;
		.kaoshiCont {
			padding: 0 80px 0 51px;
			color: #000000;
			h1 {
				font-size: 28px;
				padding-top: 38px;
				margin-bottom: 25px;
				font-weight: bold;
				display: flex;
				align-items: center;
				justify-content: center;
				line-height: 1;
				img {
					cursor: pointer;
					width: 30px;
					margin-top: 2px;
					margin-left: 5px;
				}
			}
			h2 {
				font-size: 18px;
				margin-bottom: 27px;
				text-align: center;
				padding-bottom: 34px;
				border-bottom: 1px solid #f8f8f8;
			}
			.kaoshiTm {
				h3 {
					font-size: 18px;
					font-weight: bold;
					margin: 40px 0 13px;
					text-indent: 2em;
				}
				> p {
					font-size: 16px;
					line-height: 2;
					text-indent: 2em;
					margin-bottom: 38px;
					span {
						font-weight: bold;
					}
				}
				.kaoshiXtim {
					h4 {
						font-weight: bold;
						font-size: 18px;
						margin: 40px 0;
					}
					.kaoshiT {
						margin-bottom: 44px;
						.kaoshiXx {
							padding-left: 102px;

							p {
								margin-bottom: 36px;
								font-size: 18px;
								cursor: pointer;
								&:hover {
									color: #1d7b3a;
								}
								&:last-of-type {
									margin-bottom: 0;
								}
							}
							.active {
								color: #1d7b3a;
							}
						}
						.kaoshiWt {
							display: flex;
							font-weight: bold;
							margin-bottom: 36px;
							.kaoshiDa {
								width: 72px;
								margin-right: 30px;
								position: relative;
								display: flex;
								justify-content: space-between;
								line-height: 1.2;
								span {
									position: absolute;
									top: 50%;
									left: 50%;
									transform: translate(-50%, -50%);
								}
							}
						}
					}
				}
			}
		}
		.kaoshiFixBtns {
			position: sticky;
			position: -webkit-sticky;
			float: right;
			margin-right: -202px;
			top: 10px;
			.kaoshiFixBtn {
				width: 65px;
				height: 65px;
				background: #ffffff;
				border-radius: 6px;
				display: flex;
				justify-content: center;
				align-items: center;
				flex-direction: column;
				font-size: 14px;
				color: #82807c;
				margin-bottom: 15px;
				cursor: pointer;
				img {
					width: 25px;
					height: 25px;
					margin-bottom: 4px;
				}
				i {
					font-size: 20px;
					margin-bottom: 4px;
				}
				.el-icon-close-notification {
					color: #1d7b3a;
				}
			}
			.kaoshiFixBtn1 {
				background: #d33931 !important;
				color: #fff !important;
			}
		}
		.kaoshiFixYs {
			position: sticky;
			position: -webkit-sticky;
			top: 10px;
			width: 108px;
			height: 98px;
			float: right;
			margin-right: -60px;
			color: #fff;
			background: url('@/assets/img/ys.svg') 100% no-repeat;
			.kaoshiFixYsCont {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				margin-top: -4px;
			}
			.kaoshiFixP {
				position: absolute;
				bottom: 15px;
				width: 100%;
				display: flex;
				justify-content: center;
				font-size: 12px;
				align-items: center;
				p {
					margin: 0 6px;
				}
				img {
					width: 9px;
					height: 6px;
					cursor: pointer;
					margin-top: 1px;
				}
				.img1 {
					transform: rotate(90deg);
				}
				.img2 {
					transform: rotate(90deg);
				}
			}
		}
	}
}
.cihuiBox {
	.cihuiCont {
		margin-bottom: 18px;
		padding: 0 22px;
		.cihuiItem {
			padding: 18px 0;
			display: flex;
			justify-content: space-between;
			align-items: center;
			border-bottom: 1px solid #f8f8f8;
			&:last-of-type {
				border-bottom: none;
			}
			.cihuiItemRig {
				.cihuiItemRigT {
					display: flex;
					margin-bottom: 8px;
					.cihuiItemRigTBtn {
						padding: 5px 12px;
						font-size: 12px;
						border-radius: 4px;
						margin-left: 10px;
					}
					.cihuiItemRigTBtn1 {
						background: #ffeef8;
						color: #d7198b;
					}
					.cihuiItemRigTBtn2 {
						background: #eef6ff;
						color: #1f6cf5;
					}
					.cihuiItemRigTBtn3 {
						background: #fff4ee;
						color: #f07c10;
					}
				}
				p {
					color: #878787;
					margin-top: 8px;
					font-size: 12px;
					text-align: right;
				}
			}
			.cihuiItemLef {
				display: flex;
				flex-direction: column;
				justify-content: center;

				.fgP {
					display: flex;
					align-items: center;
					img {
						margin-top: 3px;
					}
				}

				h2 {
					font-size: 24px;
					color: #000000;
					margin: 0 11px 0 0;
					font-weight: bold;
				}
				p {
					font-size: 14px;
					color: #000000;
					margin-right: 10px;
				}
				> p {
					color: #1d7b3a;
					margin-top: 10px;
				}
				img {
					width: 21px;
					height: 21px;
					cursor: pointer;
				}
				.ass {
					color: #000000;
				}
			}
		}
	}
	.cihuiBoxTit {
		height: 67px;
		display: flex;
		align-items: center;
		border-bottom: 1px solid #f8f8f8;
		justify-content: space-between;
		padding: 0 26px;
		.cihuiBoxQx {
			font-size: 18px;
			color: #8d8d8d;
			display: flex;
			align-items: center;
			h2 {
				margin-right: 47px;
				cursor: pointer;
			}
			.qxActive {
				color: #000000;
				font-weight: bold;
			}
		}
		.cihuiBoxBtns {
			display: flex;
			.cihuiBoxBtn {
				width: 100px;
				height: 36px;
				background: linear-gradient(180deg, #ffffff 0%, #f1f1f1 100%);
				border-radius: 7px;
				border: 1px solid #e0e0e0;
				margin-left: 16px;
				font-size: 14px;
				color: #000000;
				display: flex;
				justify-content: center;
				align-items: center;
				cursor: pointer;
				img {
					width: 16px;
					height: 16px;
					margin-right: 5px;
				}
			}
			.cihuiBoxBtn1 {
				background: #1d7b3a;
				border: 1px solid #14652d;
				color: #fff;
			}
		}
	}
}
</style>
